module.exports = __webpack_public_path__ + "static/media/IMG_1802.d35d05a7.jpg";